import Vue from 'vue'
import axios from 'axios'
import router from '../router/index'
import { getToken, removeToken } from '@/api/auth.js'
import { baseURL } from '@/api/apiConfig.js'

axios.defaults.withCredentials = true
axios.defaults.timeout = 10000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.headers = { 'X-Requested-With': 'XMLHttpRequest' }
axios.defaults.baseURL = baseURL
Vue.prototype.$ajax = axios


axios.interceptors.request.use((config) => {
    const isToken = (config.headers || {}).isToken === false
    if (getToken() && !isToken) {
        config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config
}, (error) => {
    return Promise.reject(error)
})
axios.interceptors.response.use(response => {
    if (response.data.code === 401) {
        removeToken()
        // 无登录信息 跳转至登录页面
        router.push('/login')
    }
    return response
})



export default axios

